/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import moment from 'moment';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_CURRENT,
  screenData: data,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_CURRENT,
  detailScrData: data,
});
//dispatch Quarter From

export const dispatchQtrRange = (data) => ({
  type: actionTypes.GET_FROM_CURRENT,
  payload: data,
});

//select option dispatch
export const getSelectedOption = (data) => ({
  type: actionTypes.SELECT_OPTION,
  payload: data,
});

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_CURRENT,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgCurrent = (data) => ({
  type: actionTypes.GET_ERROR_MSG_CURRENT,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  // dispatch(dispatchErrorMsgCurrent([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgCurrent([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
//dispatch invoice comparison
export const dispatchInvoiceComparison = (data) => ({
  type: actionTypes.GET_INVOICE_COMPARISON,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_CURRENT,
  payload: data,
});
//on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_CURRENT,
  payload: data,
});

//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
// get invoice comparison
export const getInvoiceComparisonReport = (value) => (dispatch) => {
  dispatch(dispatchInvoiceComparison([]));
  return axios
    .post(serviceEndPoint.GET_CURRENT_TO_PREVIOUS, value)
    .then((response) => {
      if (response.data.invoiceComparisonReportVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchInvoiceComparison(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchInvoiceComparison([]));
    });
};
//refresh data
export const refreshCurrentToPrevious = () => ({
  type: actionTypes.SET_REFRESH_DATA_CURRENT,
  payload: {},
});
export const refreshCurrentToPreviousDisplay = () => ({
  type: actionTypes.REFRESH_DATA_CURRENT_DISPLAY,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayObjCurrent = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_CURRENT,
  payload: data,
});
